import { render, staticRenderFns } from "./FunctionalitiesProfiles.vue?vue&type=template&id=044df5e9&scoped=true"
import script from "./FunctionalitiesProfiles.vue?vue&type=script&lang=js"
export * from "./FunctionalitiesProfiles.vue?vue&type=script&lang=js"
import style0 from "./FunctionalitiesProfiles.vue?vue&type=style&index=0&id=044df5e9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044df5e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/atlassian/application-data/bamboo/local-working-dir/AG-FRTPRSTD0-JOBCOMPILAR/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('044df5e9')) {
      api.createRecord('044df5e9', component.options)
    } else {
      api.reload('044df5e9', component.options)
    }
    module.hot.accept("./FunctionalitiesProfiles.vue?vue&type=template&id=044df5e9&scoped=true", function () {
      api.rerender('044df5e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/FunctionalitiesProfiles.vue"
export default component.exports